"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Server, Shield, Smartphone, Cloud } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const PARTNER_DATA = [{
  name: "Microsoft",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_microsoft.png",
  category: "Cloud & Productivity"
}, {
  name: "AWS",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_aws.png",
  category: "Cloud Infrastructure"
}, {
  name: "VMware",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_vmware.png",
  category: "Virtualization"
}, {
  name: "Cisco",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_cisco.png",
  category: "Networking"
}, {
  name: "Fortinet",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_fortinet.png",
  category: "Cybersecurity"
}, {
  name: "Ubiquiti",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_ubiquiti.png",
  category: "Networking"
}, {
  name: "Aruba",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_aruba.png",
  category: "Networking"
}, {
  name: "Zebra",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_zebra.png",
  category: "Industrial Devices"
}, {
  name: "Honeywell",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_honeywell.png",
  category: "Logistics"
}, {
  name: "Datalogic",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_datalogic.png",
  category: "Industrial Scanning"
}, {
  name: "Android Enterprise",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_android.png",
  category: "Mobile OS"
}, {
  name: "Veeam",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_veeam.png",
  category: "Backup & Recovery"
}, {
  name: "Dell Technologies",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_dell.png",
  category: "Hardware"
}, {
  name: "Synology",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_synology.png",
  category: "Storage"
}, {
  name: "Toshiba",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_toshiba.png",
  category: "Printing & Retail"
}, {
  name: "Epson",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_epson.png",
  category: "Printing"
}, {
  name: "Microsoft Intune",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_microsoft_intune.png",
  category: "Endpoint Management"
}, {
  name: "SOTI",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logo_soti_microsoft.png",
  category: "MDM Solutions"
}];
const marqueePartners = [...PARTNER_DATA, ...PARTNER_DATA];
export default function TechStackEcosystem() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  return <section id="tech-stack-ecosystem" className="dark bg-background text-foreground py-24 relative overflow-hidden border-t border-border/10">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--primary)_0%,_transparent_20%)] opacity-10 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ${isHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-medium mb-6">
            <Server className="size-3" />
            <span>Tecnologie Enterprise & Industrial</span>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold mb-6 tracking-tight text-white">
            Ecosistema Tecnologico
          </h2>
          
          <p className="text-lg text-muted-foreground leading-relaxed">
            L'approccio consulenziale si basa su tecnologie ampiamente adottate nel mercato enterprise e logistico per realizzare infrastrutture IT affidabili e performanti: dalle piattaforme cloud ai dispositivi operativi utilizzati nei flussi logistici.
          </p>
        </div>

        <div className="relative w-full overflow-hidden py-10 mask-linear-fade">
          <div className="absolute left-0 top-0 bottom-0 w-20 md:w-40 bg-gradient-to-r from-background to-transparent z-20 pointer-events-none"></div>
          <div className="absolute right-0 top-0 bottom-0 w-20 md:w-40 bg-gradient-to-l from-background to-transparent z-20 pointer-events-none"></div>

          <div className="flex w-max animate-scroll hover:pause-animation">
            {marqueePartners.map((partner, i) => <div key={`${partner.name}-${i}`} data-index={i} className="flex flex-col items-center justify-center mx-8 md:mx-12 group cursor-default">
                <div className="relative w-32 h-16 md:w-40 md:h-20 flex items-center justify-center transition-all duration-300">
                  <img src={partner.logo} alt={`${partner.name} logo`} className="max-w-full max-h-full object-contain filter grayscale opacity-50 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500 ease-out transform group-hover:scale-110" />
                </div>
                <span className="mt-3 text-xs font-medium text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {partner.category}
                </span>
              </div>)}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-20 max-w-5xl mx-auto">
          {[{
          icon: Cloud,
          title: "Cloud & Hybrid",
          desc: "Gestione ambienti Microsoft 365, Azure e AWS per scalabilità e resilienza."
        }, {
          icon: Shield,
          title: "Cybersecurity",
          desc: "Protezione di endpoint, identità e infrastrutture IT attraverso soluzioni di sicurezza integrate."
        }, {
          icon: Smartphone,
          title: "Industrial Mobility",
          desc: "Deployment e gestione dispositivi Zebra, Honeywell e Android Enterprise."
        }].map((item, i) => <div key={i} data-index={i} className="bg-card/30 border border-border/50 p-6 rounded-lg hover:bg-card/50 transition-colors duration-300">
              <div className="size-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary mb-4">
                <item.icon className="size-5" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">{item.title}</h3>
              <p className="text-sm text-muted-foreground">{item.desc}</p>
            </div>)}
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/20">
            <Link to="/ContactsPage">
              Richiedi supporto tecnico
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 40s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
        .mask-linear-fade {
          mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
          -webkit-mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
        }
      `}</style>
    </section>;
}